
  import React from 'react';
  import COMPONENTS from '../../components';
  import { get } from 'lodash';
  import PageLayout from '../../layout';
  import { graphql } from 'gatsby';

  class Page extends React.Component {
    state = {
      data: [],
    };

    componentDidMount() {
      let slices;

      const data = get(this, 'props.data.investorRelationsCompanyPortraitJson');

      if (data) {
        slices = Object.entries(data).map(([key, content]) => ({
          componentName: key,
          ...content,
        }));

        slices.sort(
          ({ position: positionA }, { position: positionB }) =>
            positionA - positionB
        );

        this.setState({
          data: slices,
        });
      }
    }

    render() {
      return (
        <PageLayout>
          {get(this, 'state.data').map(({ componentName, data }, index) => {
            const ComponentType = COMPONENTS[componentName];
            return <ComponentType key={index} {...data} />;
          })}
        </PageLayout>
      );
    }
  }

  export default Page;

  export const pageQuery = graphql`
    query {
      investorRelationsCompanyPortraitJson {
        
      
      
      
      
      
      Header0 {
        position
        componentName
        data {
           title type showRedLine
        }
      }
    
      VerticalTabMenu1 {
        position
        componentName
        data {
           sections {  submenutitle linkToPage }
        }
      }
    
      SubPageTable2Col2 {
        position
        componentName
        data {
           header content {  leftCol {  type text } rightCol {  type text } }
        }
      }
    
      SubPageTable2Col3 {
        position
        componentName
        data {
           header content {  leftCol {  type text } rightCol {  type text } }
        }
      }
    
      SubPageTitleBody4 {
        position
        componentName
        data {
           header textBody {  type text }
        }
      }
    
      }
    }
  `